<p [ngClass]="{'doc-body-2': boldLabel}" [innerHTML]="label"></p>
<mat-hint *ngIf="radioValue==='no'">
    <doc-form-field-error [parentForm]="parentForm" [controlName]="controlName"></doc-form-field-error>
</mat-hint>
<mat-radio-group class="optionsGroup" (change)="selectionChanged($event)">
    <!-- <mat-radio-button [value]="getValue(option)" [checked]="isChecked(option)" *ngFor="let option of options">
        {{getKey(option)}}
    </mat-radio-button> -->
</mat-radio-group>

<div *ngIf="radioValue==='yes'">
    <mat-form-field appearance="outline" floatLable="never" class="w-100 mb-3 doc-custom-input">
        <textarea matInput [placeholder]="placeholder" autocomplete="off" [value]="value" [disabled]="disabled"
            (input)="changed($event.target.value)" (blur)="touched()" [cdkTextareaAutosize]="autoResize"
            [cdkAutosizeMinRows]='maxRows' [cdkAutosizeMaxRows]='minRows' #inputEl>
        </textarea>

        <mat-hint>
            <doc-form-field-error [parentForm]="parentForm" [controlName]="controlName"></doc-form-field-error>
        </mat-hint>

    </mat-form-field>
</div>